import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraButton } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useRegistryRecord } from '../../Delivery/Registries/registryParams';
import { useRegistryRecordsEnabled } from '../registryFlags';
import { registryHref } from '../registryHref';
export function useRowOpen(kind, beforeOpen) {
    const enabled = useRegistryRecordsEnabled();
    const navigate = useNavigate();
    const location = useLocation();
    const { openRecord } = useRegistryRecord();
    const href = (id)=>registryHref({
            kind,
            id
        }, location.pathname + location.search);
    const quickLook = (id)=>{
        beforeOpen?.();
        openRecord(id);
    };
    return {
        onRowClick: (id)=>{
            const url = enabled ? href(id) : null;
            if (url) navigate(url);
            else quickLook(id);
        },
        quickLookAction: (id)=>enabled && /*#__PURE__*/ _jsx(SpecraButton, {
                size: "sm",
                variant: "ghost",
                "data-testid": Testids.deliveryRegistries.quickLook,
                onClick: ()=>quickLook(id),
                children: "Quick look"
            })
    };
}
export function OpenFullPage({ kind, id }) {
    const enabled = useRegistryRecordsEnabled();
    const location = useLocation();
    const href = registryHref({
        kind,
        id
    }, location.pathname + location.search);
    return enabled && href ? /*#__PURE__*/ _jsx(SpecraButton, {
        asChild: true,
        variant: "secondary",
        children: /*#__PURE__*/ _jsx(Link, {
            to: href,
            "data-testid": Testids.deliveryRegistries.openFullPage,
            children: "Open full page →"
        })
    }) : null;
}
